import React, { useRef, useState } from 'react';
import { Button, Col, Modal, Result, Row, Tag } from 'antd';
import DocViewer, { DocViewerRenderers } from '@cyntler/react-doc-viewer';
import {
  DownloadOutlined,
  LeftOutlined,
  RightOutlined
} from '@ant-design/icons';

const normalizeDocument = (file) => {
  if (!file) {
    return null;
  }

  return {
    uri: `${process.env.REACT_APP_API_URL}/archives/${file.id}/binary`,
    fileType: file.contentType,
    fileName: file.name
  };
};

const NoRender = () => {
  return (
    <div className="gx-w-100 gx-flex-row gx-align-items-center gx-flex-nowrap gx-justify-content-center">
      <Result title="Arquivo não pode ser exibido." />
    </div>
  );
};

const Header = (state, previousDocument, nextDocument) => {
  const { currentDocument, documents = [], currentFileNo } = state;

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = currentDocument.uri;
    link.download = currentDocument.fileName;
    link.click();
  };

  const current = currentFileNo + 1;
  const max = documents.length;

  return (
    <Row
      className="no-padding no-margin gx-mb-1"
      align="middle"
      justify="space-between"
    >
      <Col>
        <span className="gx-font-weight-semi-bold">
          {currentDocument.fileName}
        </span>
      </Col>
      <Col>
        <Tag color="magenta">{`${current} / ${max}`}</Tag>
        <Button
          onClick={handleDownload}
          icon={<DownloadOutlined />}
          type="primary"
        >
          Baixar
        </Button>
        <Button onClick={previousDocument} icon={<LeftOutlined />} />
        <Button onClick={nextDocument} icon={<RightOutlined />} />
      </Col>
    </Row>
  );
};

const ShowFilesModal = ({ onClose, files = [], initialValue }) => {
  const docViewerRef = useRef(null);
  const [activeDocument, setActiveDocument] = useState(
    normalizeDocument(initialValue)
  );

  if (!Array.isArray(files) || files.length <= 0) {
    return null;
  }

  const handleDocumentChange = (document) => {
    setActiveDocument(document);
  };

  return (
    <Modal
      visible
      title="Visualizar"
      width="80%"
      bodyStyle={{ height: 510 }}
      onCancel={onClose}
      footer={null}
    >
      <DocViewer
        ref={docViewerRef}
        config={{
          header: { overrideComponent: Header },
          noRenderer: { overrideComponent: NoRender }
        }}
        activeDocument={activeDocument}
        onDocumentChange={handleDocumentChange}
        documents={files.map(normalizeDocument)}
        pluginRenderers={DocViewerRenderers}
        language="pt"
      />
    </Modal>
  );
};

export default ShowFilesModal;
